// ********************
// *** NAV LOCATION ***
// ********************

export const LOCATION_HOME = 'LOCATION_HOME'
export const LOCATION_VIEW_ALL_TRIPS = 'LOCATION_VIEW_ALL_TRIPS'
export const LOCATION_VIEW_TRIP = 'LOCATION_VIEW_TRIP'
export const LOCATION_VIEW_TRIP_AS_LIST = 'LOCATION_VIEW_TRIP_AS_LIST'
export const LOCATION_VIEW_TRIP_AS_MAP = 'LOCATION_VIEW_TRIP_AS_MAP'
export const LOCATION_VIEW_TRIP_EVENT = 'LOCATION_VIEW_TRIP_EVENT'
export const LOCATION_VIEW_TRIP_EVENT_INFO = 'LOCATION_VIEW_TRIP_EVENT_INFO'
export const LOCATION_VIEW_TRIP_LIST_EVENT_INFO = 'LOCATION_VIEW_TRIP_LIST_EVENT_INFO'
export const LOCATION_VIEW_TRIP_EVENT_INFO_DAY_MEDIA = 'LOCATION_VIEW_TRIP_EVENT_INFO_DAY_MEDIA'
export const LOCATION_VIEW_TRIP_LIST_EVENT_INFO_DAY_MEDIA = 'LOCATION_VIEW_TRIP_LIST_EVENT_INFO_DAY_MEDIA'
export const LOCATION_ADD_TRIP = 'LOCATION_ADD_TRIP'
export const LOCATION_EDIT_TRIP = 'LOCATION_EDIT_TRIP'
export const LOCATION_404 = 'LOCATION_404'

// ****************
// *** SETTINGS ***
// ****************

export const SET_VIDEO_RESOLUTION_DISPLAY = 'SET_VIDEO_RESOLUTION_DISPLAY'

// ************
// *** TRIP ***
// ************

export const ACTION_CREATE_NEW_TRIP = 'ACTION_CREATE_NEW_TRIP'
export const ACTION_ADD_TRIP_LOCATION = 'ACTION_ADD_TRIP_LOCATION'
export const ACTION_UPDATE_TRIP_ITINERARY = 'ACTION_UPDATE_TRIP_ITINERARY'
export const ACTION_UPDATE_TRIP_LOCATION = 'ACTION_UPDATE_TRIP_LOCATION'
export const VIEW_TRIP_MEDIA = 'VIEW_TRIP_MEDIA'

// ****************
// *** UI STATE ***
// ****************

export const OPEN_MAGIC_DRAWER = 'OPEN_MAGIC_DRAWER'
export const CLOSE_MAGIC_DRAWER = 'CLOSE_MAGIC_DRAWER'



// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js